module.exports = __webpack_public_path__ + "img/eqHeader1.aebac958.png";